<template>
  <div class="notice-header">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "NoticeHeader",
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
.notice-box {
  &.-success {
    > .notice-header {
      :deep(.heading) {
        color: $primary;
        font-size: 18px;
        line-height: 22px;
        font-weight: bold;
        @include mq-up(md) {
          font-size: 24px;
          line-height: 32px;
        }
      }
      :deep(.headingsm) {
        color: $black;
        font-size: 14px;
        line-height: 26px;
        font-weight: bold;
        @include mq-up(md) {
          font-size: 24px;
          line-height: 38px;
        }
      }
      :deep(.headinglg) {
        color: $primary;
        font-size: 20px;
        line-height: 26px;
        font-weight: bold;
        @include mq-up(md) {
          font-size: 32px;
          line-height: 38px;
        }
      }
    }
  }
  &.-cancel {
    > .notice-header {
      :deep(.heading) {
        color: $black;
        font-size: 18px;
        line-height: 22px;
        font-weight: bold;
        @include mq-up(md) {
          font-size: 24px;
          line-height: 32px;
        }
      }
      :deep(.headinglg) {
        color: $black;
        font-size: 20px;
        line-height: 26px;
        font-weight: bold;
        @include mq-up(md) {
          font-size: 32px;
          line-height: 38px;
        }
      }
    }
  }
  &.-error {
    > .notice-header {
      :deep(.heading) {
        color: $danger;
        font-size: 18px;
        line-height: 22px;
        font-weight: bold;
        @include mq-up(md) {
          font-size: 24px;
          line-height: 32px;
        }
      }
    }
  }
  &.-alert {
    > .notice-header {
      :deep(.heading) {
        color: $danger;
        font-size: 16px;
        line-height: 24px;
        font-weight: bold;
        @include mq-up(md) {
          font-size: 20px;
          line-height: 28px;
        }
      }
    }
  }
  &.-point {
    > .notice-header {
      :deep(.heading) {
        color: $black;
        font-size: 16px;
        line-height: 24px;
        font-weight: bold;
        @include mq-up(md) {
          font-size: 20px;
          line-height: 28px;
        }
      }
    }
  }
}
</style>
